'use client';

import { useState } from 'react';
import classNames from 'classnames';
import { ComponentType, GetPageComponentItemViewModel, GetPageComponentViewModel } from '@/types/cml-api';
import { sendCtaClickEvent } from '@/features/analytics/datalayer/datalayer';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import DetailModal from './detail-modal';
import { deviceTypeClassGenerator } from '../../_utils/device-type-handlers';
interface Props {
  data: GetPageComponentViewModel;
}
const TextStory = ({
  data
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const [selectedIndex, setSelectedIndex] = useState<number>();
  const items = data.items || [];
  const sortKey = data.sortKey || '';
  if (!items?.length) return;
  const handleClick = (data: GetPageComponentItemViewModel, index: number) => {
    const id = data?.id || '';
    const itemIndex = data?.index || 0;
    const name = sortKey ?? '';
    const image = isMobile ? data?.mobileImageUrl : data?.desktopImageUrl;
    sendCtaClickEvent({
      componentId: id,
      elementType: ComponentType.TextStory,
      elementName: name,
      itemID: id,
      elementIndex: itemIndex,
      destinationUrl: '',
      ImageUrl: image
    });
    Webengage.trackCtaAction({
      component_id: id,
      banner_type: ComponentType.TextStory,
      banner_name: name,
      item_id: id,
      banner_index: itemIndex,
      url_destination: '',
      image_url: image
    });
    setSelectedIndex(index);
  };
  const handleClose = () => setSelectedIndex(undefined);
  const backHandler = () => setSelectedIndex(prev => prev === 0 ? 2 : (prev || 0) - 1);
  const nextHandler = () => setSelectedIndex(prev => prev === 2 ? 0 : (prev || 0) + 1);
  const selectedItem = typeof selectedIndex === 'number' ? items.at(selectedIndex) : undefined;
  return <>
            <DetailModal sortKey={sortKey} data={selectedItem} handleClose={handleClose} backHandler={backHandler} nextHandler={nextHandler} data-sentry-element="DetailModal" data-sentry-source-file="index.tsx" />
            <div className={classNames('homepage-container', deviceTypeClassGenerator(data.deviceTypes || ''))}>
                <span className='text-body-14 font-bold'>{data.title}</span>

                <div className='mt-2 grid grid-cols-3 gap-2'>
                    {items.map((item, index) => <button key={item.id} onClick={() => handleClick(item, index)} className='relative rounded border border-solid border-primary-main'>
                            <span className='absolute right-0 top-0 z-10 h-full w-full bg-[#0a0a0a66]' />
                            <img src={item.mobileImageUrl} alt={item.title} className='h-full w-full' />
                            <span className='absolute right-1/2 top-1/2 z-20 line-clamp-3 w-4/5 -translate-y-1/2 translate-x-1/2 text-ellipsis text-caption-12 font-medium text-text-white'>
                                {item.title}
                            </span>
                        </button>)}
                </div>
            </div>
        </>;
};
export default TextStory;